import CS_LANG from './cs.js';
import DE_LANG from './de.js';
import EN_LANG from './en.js';
import PL_LANG from './pl.js';
import { LANG_OPTIONS } from '@/common/constants/languages';

const TRANSLATIONS = {
	[LANG_OPTIONS.english]: EN_LANG,
	[LANG_OPTIONS.polish]: PL_LANG,
	[LANG_OPTIONS.german]: DE_LANG,
	[LANG_OPTIONS.czech]: CS_LANG,
};

export const getTranslations = (lang) =>
	TRANSLATIONS[lang] ?? TRANSLATIONS[LANG_OPTIONS.english];

export default TRANSLATIONS;
